'use client'

import dynamic from 'next/dynamic'

const CookieConsent = dynamic(() => import('./CookieConsent'), { ssr: false })
const BottomNav = dynamic(() => import('./BottomNav'), { ssr: false })
const WebVitals = dynamic(() => import('./WebVitals'), { ssr: false })
const PageViewTracker = dynamic(() => import('./PageViewTracker'), { ssr: false })

export default function LazyComponents() {
  return (
    <>
      <WebVitals />
      <PageViewTracker />
      <CookieConsent />
      <BottomNav />
    </>
  )
}
